// extracted by mini-css-extract-plugin
module.exports = {"columnsItem":"ColumnsItem_columnsItem__S1jqX","text":"ColumnsItem_text__SAm6W","title":"ColumnsItem_title__Cj8_6"};